import { type QueryOptions } from '@tanstack/query-core'

import { type TaxCategoryEntity } from '@/libs/api'

import { fetchTaxCategories } from '../api'
import {
  type TaxCategoriesSelectQueryParams,
  taxCategoriesQueryKeys
} from '../query-keys'

/**
 * Select 用の税区分一覧取得 QueryOptions。
 * - `isActive=true` 指定が既定（明示的に渡される想定）
 * - sortOrder 順は BE のレスポンス保証に依存
 */
export const getTaxCategoriesSelectQueryOptions = (
  params: TaxCategoriesSelectQueryParams
): Required<
  Pick<QueryOptions<TaxCategoryEntity[]>, 'queryKey' | 'queryFn'>
> => {
  return {
    queryKey: taxCategoriesQueryKeys.select(params),
    queryFn: async ({ signal }) => {
      const { data } = await fetchTaxCategories(params, signal)
      return data
    }
  }
}
